export default "__VITE_ASSET__DtAHL8pS__"